import { useCallback, useEffect, useRef, useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import SaveComboCard from './SaveComboCard';
import {
  CardScrollDiv,
  RelativeDiv,
  SaveComboTitle,
  ScrollArrow,
  ScrollContainer,
  VermArrow,
} from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function PdpCombo({ productData, showNewDiaperVariantUx }) {
  const comboData = productData?.comboProducts;
  const [scrollX, setScrollX] = useState(0);
  const [leftArrowbtn, setLeftArrowbtn] = useState(false);
  const [rightArrowbtn, setRightArrowbtn] = useState(false);
  const [containerRect, setContainerRect] = useState(null);
  const firstRender = useRef(true);
  const comboCardRef = useCallback(
    (elem) => {
      if (elem != null) {
        setContainerRect(elem.getBoundingClientRect());
        if (elem.scrollWidth > elem.clientWidth && firstRender.current) {
          firstRender.current = false;
          setRightArrowbtn(true);
        }
      }
    },
    [leftArrowbtn, rightArrowbtn],
  );
  const isElementInViewport = (el) => {
    const rect = el?.getBoundingClientRect();
    // returns  [elementVisible, rightOffset, leftOffset]
    return [
      rect?.top >= containerRect.top &&
        rect?.left >= containerRect.left - 5 &&
        rect?.bottom <= containerRect.bottom &&
        rect?.right <= containerRect.right + 5,
      rect?.right - containerRect.right,
      containerRect.left - rect?.left,
    ];
  };

  const arrowsInViewChecker = () => {
    setTimeout(() => {
      const firstElement = document.getElementById('first');
      const lastElement = document.getElementById('last');
      const [firstVisible] = isElementInViewport(firstElement);
      const [lastVisible] = isElementInViewport(lastElement);
      if (firstVisible) {
        setLeftArrowbtn(false);
        setRightArrowbtn(true);
      } else if (lastVisible) {
        setLeftArrowbtn(true);
        setRightArrowbtn(false);
      } else {
        setLeftArrowbtn(true);
        setRightArrowbtn(true);
      }
    }, 350);
  };

  const arrowHandler = (direc) => {
    const firstElement = document.getElementById('first');
    const lastElement = document.getElementById('last');
    const [firstVisible, firstOffsetRight, firstOffsetLeft] =
      isElementInViewport(firstElement);
    const [lastVisible, lastOffsetRight, lastOffsetLeft] =
      isElementInViewport(lastElement);
    if (direc == 'left') {
      if (firstVisible) {
      } else {
        firstOffsetLeft > 280
          ? setScrollX(scrollX + 280)
          : setScrollX(scrollX + firstOffsetLeft);
      }
    } else {
      if (lastVisible) {
      } else {
        lastOffsetRight > 280
          ? setScrollX(scrollX - 280)
          : setScrollX(scrollX - lastOffsetRight);
      }
    }
    arrowsInViewChecker();
  };

  useEffect(() => {
    if (comboData) {
      fireEvent({
        category: 'served_section_in_pdp',
        id: productData?.id,
        card_ids: comboData.map((item) => item.id).toString(),
        section_name: 'save_more_with_combos',
      });
    }
  }, [comboData]);

  return (
    <RelativeDiv showNewDiaperVariantUx={showNewDiaperVariantUx}>
      <SaveComboTitle>Save more with Combos 💰💰</SaveComboTitle>
      <CardScrollDiv ref={comboCardRef}>
        {rightArrowbtn && (
          <ScrollArrow
            visible={rightArrowbtn}
            right
            onClick={() => {
              arrowHandler('right');
            }}
          >
            <VermArrow
              src={images.pinkrightarrow}
              alt=""
              rotate="rotate(180deg)"
            />
          </ScrollArrow>
        )}
        {leftArrowbtn && (
          <ScrollArrow
            visible={leftArrowbtn}
            onClick={() => {
              arrowHandler('left');
            }}
          >
            <VermArrow src={images.pinkrightarrow} alt="" />
          </ScrollArrow>
        )}
        <ScrollContainer onWheel={arrowsInViewChecker} xValue={scrollX}>
          <SaveComboCard comboData={comboData} productData={productData} />
        </ScrollContainer>
      </CardScrollDiv>
    </RelativeDiv>
  );
}
